import script from "./tagsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./tagsModal.vue?vue&type=script&setup=true&lang=js"

import "./tagsModal.vue?vue&type=style&index=0&id=025ac4f7&scoped=true&lang=css"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025ac4f7"]])

export default __exports__